WL.registerComponent('sack-controller', {
    levelControllerObject: { type: WL.Type.Object },
    sackIndex: { type: WL.Type.Int, default: 0 }
}, {
    start() {
        this.levelController = this.levelControllerObject.getComponent('level-controller');
        this.physx = this.object.getComponent('physx');
        this.physx.onCollision(this.onCollision.bind(this));
        this.onCollisionDisabled = false;
    },
    onCollision(event, other) {        
        if(this.onCollisionDisabled) return;
        /* Nothing to do on "uncollide" events */
        if (event == WL.CollisionEventType.TouchLost) return;                
        
        let handleGrabbed = other.object.getComponent('handle-grabbed');
        if (!handleGrabbed || handleGrabbed.isGrabbed) return;
        
        let wrapper = other.object.getComponent('wrapper');        
        if (wrapper) {            
            
            this.onCollisionDisabled = true;
            setTimeout(() => {this.onCollisionDisabled = false}, 500);

            let result = this.levelController.validate(wrapper.getTypes(), this.sackIndex);            
            if (result) {
                window.SW.gameState.score ++;
                setTimeout(()=>{
                    if(!window.SW.instructions.play('sack')){
                        window.SW.soundEffects.playSound(Sounds.merryChristmas);
                    }
                },500);
                poof(other.object.getTranslationWorld([]));
                let movement = other.object.getComponent('conveyor-movement');
                movement.sacked();
                this.levelController.nextLevel();
            }
        }

    }
});
